export default {


  headline: 'SIEGENIA Mediacenter',
  search_info: 'Wat zoekt u',
  back: 'terug',
  no_results: 'Geen resultaten gevonden. Gelieve de zoekopdracht te controleren',
  service: {
    downloads: 'Downloads',
    videos: 'Videos',
    faq: 'FAQ'
  },
  service_search: {
    category_placeholder: "Filter op categorie"
  },
  service_download: {
    select_info: 'Wat zoekt u?',
    select_productgroup: 'Selecteer Productgroep',
    select_product: 'Selecteer Product',
    select_type: 'Selecteer het Medium',
    option_language: "taal",
    types: {
      tec_info: 'Technische Informatie',
      installation: 'Montagehandleiding',
      planning: 'Planning',
      catalog: 'Broschures',
      order_forms: 'Bestelformulier',
      maintenance: 'Onderhoud, Bediening en Verzorging',
      construction_drawings: 'Constructie tekeningen',
      software: 'Software',
      certificate: 'Certificaten & Richtlijnen',
      press: 'Pers & Marketingdocumenten',
      videos: 'Video',
      undefined: 'Overig',
      commercial: 'Commercial',
      product_video: 'Productvideo',
      operating: 'Bediening',
      'function': 'Functie',
      'assembly': 'Montage',
      'installation_video': 'Inbouw/montage',
      'assembly_instructions': 'Montagehandleiding',
      'brochure': 'Brochure',
      'tec_catalog': 'Technische catalogi',
      'tec_sheet': 'Technische informatiebladen',
      'usage_charts': 'Toepassingsdiagrammen',
      'profile_sheet': 'Profielgegevensbladen',
      'operations_manual': 'Bedienings- en onderhoudsinstructies',
      hardware_info: 'Passende informatie',
      'installation_suggestion' : 'Installatie voorstel',
      'general' : 'Als een algemene regel',
      'troubleshooting' : 'Probleemoplossen',
      "smarthome:general" : 'Als een algemene regel',
      'smarthome:installation' : 'Installatie',
      'smarthome:troubleshooting' : 'Probleemoplossen',
      'smarthome:startup' : 'Installatie',
      'smarthome:operating' : 'Handleiding',
      'order' : 'Bestelling',

    },
    filter_sorting: {
      filter: "Filter",
      sorting: "Sorteren",
      asc: "Titel oplopend (A-Z)",
      desc: "Titel aflopend (Z-A)",
      date_asc: "Datum oudste eerst",
      date_desc: "Datum nieuwste eerst",
      relevance: "Relevantie",
      facet_headline: "Zoekresultaten filteren",
      facet_filter_type_id: "Type",
      facet_filter_lang: "Talen",
      facet_filter_level_0: "Categorie",
      filter_remove: "Resetfilter",
      show_hide: "Toon filters",
    },
    result: {
      count_media: "Media",
      show_results: "laat resulaten zien",
      preview_type_catalog: "HTML",
      lang_not_available: "Niet beschikbaar in uw taal",
      version_info: "Deze link leidt naar de laatste versie van de documentatie. Als u een oudere versie nodig heeft, neem dan contact op met uw SIEGENIA klantadviseur."
    }
  }

};
